import { CurrencyEnum, CurrencyExchange } from "@finway-group/shared/lib/models"

export const testCurrencyExchangeData = {
    baseCurrency: CurrencyEnum.EUR,
    rates: [
        {
            currencyName: CurrencyEnum.EUR,
            conversionFactor: 0.884956,
        },
    ],
} as CurrencyExchange
